import React from 'react';
import { Sun, Moon } from '@phosphor-icons/react';

const ThemeToggle = ({ isDarkMode, toggleTheme }) => {
  return (
    <button
      onClick={toggleTheme}
      className="p-2 rounded-full bg-white dark:bg-white/10 border border-gray-200 dark:border-white/10 shadow-md hover:scale-105 transition-all duration-200"
      aria-label="Toggle Theme"
    >
      {isDarkMode ? (
        <Sun className="w-4 h-4 text-yellow-400" />
      ) : (
        <Moon className="w-4 h-4 text-slate-700" />
      )}
    </button>
  );
};

export default ThemeToggle;
